import { InputRadio } from "components/Atomos/Form/Elements/InputRadio";
import { useEffect } from "react";
import { Control, FieldError } from "react-hook-form";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { obterEspecieAnimal } from "store/modules/zoonose/actions/obterEspecieAnimal";

interface InputRadioAnimalProps {
  error?: FieldError;
  control: Control<any, object>;
}

export const InputRadioEspecie = ({
  control,
  error
}: InputRadioAnimalProps) => {
  const dispatch = useAppDispatch();

  const { successPayload: especies, isRequesting } = useTypedSelector(
    (state) => state.zoonose.obterEspecieAnimal
  );

  useEffect(() => {
    dispatch(obterEspecieAnimal());
  }, []);

  return (
    <InputRadio
      direction="row"
      spacing={2}
      name="especie"
      label="Espécie"
      option={especies.map((x) => ({
        value: String(x.value),
        label: x.name
      }))}
      isDisabled={isRequesting}
      control={control}
      error={error}
      size="sm"
    />
  );
};
